var React = require('react');

function IconAlert (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeWidth":"2","key":1},[React.createElement("path",{"stroke":"#4468CC","d":"M74.5 82a6 6 0 11-12 0h-12a18 18 0 016-13.4V60a12 12 0 0124 0v8.6a18 18 0 016 13.4h-12zm-6 2a2 2 0 002-2h-4c0 1.1.9 2 2 2z","key":0}),React.createElement("path",{"stroke":"#4468CC","d":"M68.5 117a48.8 48.8 0 0049-49 49 49 0 00-98 0","key":1}),React.createElement("path",{"stroke":"#6DE4F0","d":"M78.4 11.9a57 57 0 1041 30.4","key":2})])]);
}

IconAlert.defaultProps = {"viewBox":"0 0 137 136"};

module.exports = IconAlert;

IconAlert.default = IconAlert;
